import React from 'react'
import css from './style.scss'

export default ({type,payload,label,active, data})=>{
  if(active){
    return (
      <div className={css.tooltip}>
        {`${data[label].name} - ${payload[0].value}`}
      </div>
    )
  }else{
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/account_page/stats/sections/tooltip.js